import { create } from 'zustand';

const useAppStore = create((set) => ({
  dictationEnabled: false,
  setDictationEnabled: (enabled) => set({ dictationEnabled: enabled }),
}));

export default useAppStore;
